import { useEffect } from 'react';
import { useParams } from 'react-router';

interface HubInviteRedirectModalProps {
  redirect: (id: string) => void;
}

function HubInviteRedirect({ redirect }: HubInviteRedirectModalProps) {
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    redirect(id);
  }, []);

  return <h1 className="p-5">Redirecting...</h1>;
}

export default HubInviteRedirect;
